export default __webpack_public_path__ + "static/media/movie_4.e0732376.png";